var map = {
	"./fonts/Montserrat-Bold.woff": 16431,
	"./fonts/Montserrat-Bold.woff2": 68511,
	"./fonts/loos-latin-bold.woff": 41574,
	"./fonts/loos-latin-bold.woff2": 54480,
	"./img/OlainFarm-card-bg.png": 87044,
	"./img/article-preview.jpg": 27879,
	"./img/auth_bg_image.svg": 37518,
	"./img/authorization-page.jpg": 70649,
	"./img/avatar-community-1.jpg": 77133,
	"./img/avatar-community-2.jpg": 28642,
	"./img/avatar-thumb-1.jpg": 51846,
	"./img/avatar-thumb-2.jpg": 79601,
	"./img/avatar-thumb-3.jpg": 48916,
	"./img/avatar-thumb-4.jpg": 16703,
	"./img/avatar-thumb.jpg": 92728,
	"./img/banner-bg.png": 46204,
	"./img/card-bg.png": 62636,
	"./img/certificate.jpeg": 94472,
	"./img/certificate_doclub_tv.jpg": 86366,
	"./img/contact-icons/facebook.svg": 12564,
	"./img/contact-icons/file.svg": 9714,
	"./img/contact-icons/geo.svg": 69559,
	"./img/contact-icons/instagram.svg": 5124,
	"./img/contact-icons/mail.svg": 87701,
	"./img/contact-icons/other-social.svg": 7942,
	"./img/contact-icons/phone-call.svg": 96529,
	"./img/contact-icons/support.svg": 66037,
	"./img/contact-icons/tg-solid.svg": 32665,
	"./img/contact-icons/tg.svg": 2331,
	"./img/contact-icons/whatsapp.svg": 17634,
	"./img/courses/TASHIMED/VITRUM.svg": 46524,
	"./img/courses/TASHIMED/banner-bg-trevojnie-rasstoristva.png": 73040,
	"./img/courses/TASHIMED/banner-bg.png": 5555,
	"./img/courses/TASHIMED/banner.png": 66067,
	"./img/courses/TASHIMED/card-bg-2.png": 96782,
	"./img/courses/TASHIMED/card-bg-3.png": 39799,
	"./img/courses/TASHIMED/card-bg.png": 52995,
	"./img/courses/TASHIMED/course-card-bg.png": 98095,
	"./img/courses/TASHIMED/course-card-bg2.png": 65357,
	"./img/courses/TASHIMED/course-card-bg3.png": 2116,
	"./img/courses/TASHIMED/course-card-bg4 copy.png": 96468,
	"./img/courses/TASHIMED/course-card-bg4.png": 56923,
	"./img/courses/TASHIMED/course-card-bg4_5.png": 31571,
	"./img/courses/TASHIMED/ТашИУВ-first-child.png": 69948,
	"./img/courses/TASHIMED/ТашИУВ.png": 59008,
	"./img/courses/ab/ab-banner.svg": 51113,
	"./img/courses/ab/ab-play.svg": 91629,
	"./img/courses/ab/ab-video-preview copy.jpg": 20706,
	"./img/courses/ab/ab-video-preview.jpg": 39065,
	"./img/courses/ab/certificate/preview.png": 64081,
	"./img/courses/ab/events/event-1.webp": 8450,
	"./img/courses/ab/events/event-2.webp": 15875,
	"./img/courses/ab/events/event-3.webp": 12032,
	"./img/courses/ab/events/event-4.webp": 41177,
	"./img/courses/ab/events/event-5.webp": 80286,
	"./img/courses/ab/events/event-6.webp": 77439,
	"./img/courses/ab/events/event-7.webp": 75900,
	"./img/courses/ab/events/event-8.webp": 87157,
	"./img/courses/ab/lectors/avatar-1.svg": 7739,
	"./img/courses/ab/lectors/avatar-2.svg": 26376,
	"./img/courses/ab/lectors/avatar-3.png": 95923,
	"./img/courses/ab/logo.svg": 55706,
	"./img/courses/ab/medications/Ospamox_DT.png": 44186,
	"./img/courses/ab/medications/Ospamox_powder.png": 63253,
	"./img/courses/ab/modal/close.svg": 91807,
	"./img/courses/ab/video/mobile-video.png": 51693,
	"./img/courses/course-1.png": 59128,
	"./img/courses/course-2.png": 54739,
	"./img/courses/landing/authorization-page.jpg": 50764,
	"./img/courses/landing/banner-bg.png": 75403,
	"./img/courses/landing/certificate_doclub_tv.jpg": 76861,
	"./img/courses/landing/course-1.jpeg": 3457,
	"./img/courses/landing/course-1.png": 94412,
	"./img/courses/landing/course-2.jpeg": 96352,
	"./img/courses/landing/course-2.png": 61447,
	"./img/courses/landing/course-2.webp": 30660,
	"./img/courses/landing/course-3.jpg": 21690,
	"./img/courses/landing/course-3.png": 69310,
	"./img/courses/landing/course-4.jpg": 11177,
	"./img/courses/landing/desktop-personal-page-old.png": 59422,
	"./img/courses/landing/desktop-personal-page.png": 54650,
	"./img/courses/landing/doc_doriclub_uz_card.png": 80635,
	"./img/courses/landing/doctor.png": 61452,
	"./img/courses/landing/doriclub_uz_card.png": 35518,
	"./img/courses/landing/event-announcement-banner.png": 76786,
	"./img/courses/landing/lectors/doctor.png": 18561,
	"./img/courses/landing/lectors/lector-1.png": 84517,
	"./img/courses/landing/lectors/lector-2.png": 30510,
	"./img/courses/landing/lectors/lector-3.png": 59735,
	"./img/courses/landing/mockup.png": 27168,
	"./img/courses/landing/og.jpeg": 1852,
	"./img/courses/landing/pasport.jpg": 76520,
	"./img/courses/landing/preductal.png": 50917,
	"./img/courses/landing/summary.jpg": 87161,
	"./img/default-work-place-logo.png": 26281,
	"./img/desktop-personal-page-old.png": 19609,
	"./img/desktop-personal-page.png": 28157,
	"./img/doc_doriclub_uz_card.png": 51822,
	"./img/doclub-logo.svg": 39061,
	"./img/doctor copy.png": 54926,
	"./img/doctor.png": 43705,
	"./img/doriclub_uz_card.png": 5219,
	"./img/event-announcement-banner.png": 56773,
	"./img/event-main-picture.png": 56251,
	"./img/exp-adidas.png": 65046,
	"./img/exp-id.png": 97369,
	"./img/logo copy.svg": 33584,
	"./img/logo-black.svg": 72431,
	"./img/logo-voicee copy.svg": 46920,
	"./img/logo-voicee-dark.png": 3134,
	"./img/logo-voicee.png": 5683,
	"./img/logo-voicee.svg": 76121,
	"./img/logo-white.svg": 64229,
	"./img/logo.png": 10961,
	"./img/logo.svg": 39249,
	"./img/media-thumb-1.jpg": 28643,
	"./img/media-thumb-2.jpg": 98932,
	"./img/parent-course-icon.svg": 98804,
	"./img/pasport.jpg": 90059,
	"./img/personal-badge-icon.svg": 38776,
	"./img/preductal.png": 39334,
	"./img/public-qr.svg": 88737,
	"./img/qr-demo.png": 43341,
	"./img/sidebar-bg.jpg": 90688,
	"./img/stories-thumb-1.jpg": 76432,
	"./img/stories-thumb-2.jpg": 60767,
	"./img/stories-thumb-3.jpg": 48098,
	"./img/stories-thumb-4.png": 7929,
	"./img/stories-thumb-5.jpg": 23604,
	"./img/summary-event-ASPECTS-OF-TREATMENT-OF-THE-PERIPHERAL-NERVOUS-SYSTEM.jpeg": 26337,
	"./img/summary-event-olpha.jpeg": 51505,
	"./img/summary-feb20-olpha.jpeg": 71646,
	"./img/summary-feb21-olpha.jpeg": 38689,
	"./img/summary.jpg": 33762,
	"./img/voicee-black.svg": 63037,
	"./img/voicee.svg": 43011,
	"./img/wired-outline-magic-wand-hover-pinch.gif": 19380,
	"./scss/animations.scss": 71717,
	"./scss/base.scss": 7703,
	"./scss/colors.scss": 91726,
	"./scss/fonts.scss": 93840,
	"./scss/main.scss": 20767,
	"./scss/normalize.scss": 85393,
	"./scss/transitions.scss": 28122,
	"./scss/variables.scss": 60867,
	"./svg/ATMOS.svg": 22069,
	"./svg/IT_Park.svg": 64801,
	"./svg/alert-approved.svg": 52207,
	"./svg/alert-danger.svg": 45219,
	"./svg/alert-error.svg": 44716,
	"./svg/alert-question.svg": 86126,
	"./svg/alert-success.svg": 15255,
	"./svg/arrow-left.svg": 16006,
	"./svg/arrow-right.svg": 74213,
	"./svg/briefcase.svg": 75959,
	"./svg/calendar.svg": 59671,
	"./svg/camera.svg": 64704,
	"./svg/certificate.svg": 48442,
	"./svg/certificates.svg": 55781,
	"./svg/checked.svg": 38488,
	"./svg/clock-regular.svg": 51586,
	"./svg/clock.svg": 12585,
	"./svg/content.svg": 58424,
	"./svg/course-end-date.svg": 34291,
	"./svg/courses/course-complete.svg": 36385,
	"./svg/delete.svg": 55359,
	"./svg/diplom-error.svg": 42633,
	"./svg/diplom.svg": 17468,
	"./svg/doclub/attract-patients.svg": 68307,
	"./svg/doclub/check.svg": 4759,
	"./svg/doclub/manage-reputation.svg": 96972,
	"./svg/doclub/registration.svg": 8194,
	"./svg/doclub/update-personal-info.svg": 81596,
	"./svg/doclub/update-profile.svg": 27050,
	"./svg/doclub/upload-photo.svg": 4789,
	"./svg/edit-alt.svg": 37347,
	"./svg/ellipsis-vertical.svg": 64703,
	"./svg/geo.svg": 33944,
	"./svg/humo.svg": 66744,
	"./svg/icon-arrow-right-base.svg": 30191,
	"./svg/icon-bell.svg": 63380,
	"./svg/icon-chevron-right-grey.svg": 4947,
	"./svg/icon-chevron-right.svg": 77765,
	"./svg/icon-chevron-up.svg": 43138,
	"./svg/icon-close-white.svg": 60617,
	"./svg/icon-close.svg": 3413,
	"./svg/icon-crown.svg": 24564,
	"./svg/icon-download.svg": 76527,
	"./svg/icon-exit.svg": 76995,
	"./svg/icon-external-link.svg": 95807,
	"./svg/icon-file-grey.svg": 65115,
	"./svg/icon-file.svg": 66685,
	"./svg/icon-filter.svg": 74201,
	"./svg/icon-heart-blue-filled.svg": 53391,
	"./svg/icon-heart-blue.svg": 48938,
	"./svg/icon-heart.svg": 53965,
	"./svg/icon-mark.svg": 7068,
	"./svg/icon-people.svg": 3102,
	"./svg/icon-person.svg": 48700,
	"./svg/icon-plane.svg": 81347,
	"./svg/icon-plus.svg": 76739,
	"./svg/icon-search.svg": 32335,
	"./svg/icon-share.svg": 71500,
	"./svg/icon-star.svg": 34999,
	"./svg/icon-tick.svg": 14656,
	"./svg/icon-transaction.svg": 72645,
	"./svg/icon-white-plus.svg": 59327,
	"./svg/icon-yandex.svg": 96020,
	"./svg/it-park.svg": 459,
	"./svg/landing/doctors-community.svg": 48771,
	"./svg/landing/document.svg": 17906,
	"./svg/landing/education-course.svg": 53365,
	"./svg/landing/education.svg": 30033,
	"./svg/landing/increase-schedule.svg": 32133,
	"./svg/landing/online-conferences.svg": 86910,
	"./svg/like-regular.svg": 15743,
	"./svg/like-solid.svg": 68330,
	"./svg/logo-copy.svg": 3538,
	"./svg/logo-kg.svg": 60883,
	"./svg/logo.svg": 90160,
	"./svg/mail-2.svg": 19349,
	"./svg/mail.svg": 51192,
	"./svg/materials/icon-chat.svg": 8238,
	"./svg/materials/icon-education.svg": 35822,
	"./svg/materials/icon-events.svg": 65799,
	"./svg/materials/icon-materials.svg": 10310,
	"./svg/materials/icon-media.svg": 85144,
	"./svg/materials/icon-presentation.svg": 16540,
	"./svg/materials/mdi-login.svg": 40652,
	"./svg/materials/mdi-register.svg": 7494,
	"./svg/mdi-account-circle.svg": 20810,
	"./svg/mdi-check-circle-outline.svg": 35792,
	"./svg/mdi-check.svg": 31112,
	"./svg/mdi-chevron-down.svg": 63390,
	"./svg/mdi-chevron-left.svg": 68309,
	"./svg/mdi-chevron-right.svg": 66520,
	"./svg/mdi-clock.svg": 37282,
	"./svg/mdi-close.svg": 83124,
	"./svg/mdi-information-outline.svg": 1763,
	"./svg/mdi-refresh.svg": 26073,
	"./svg/megafon--large.svg": 79155,
	"./svg/module/checked.svg": 3039,
	"./svg/module/presentation-done.svg": 67845,
	"./svg/module/presentation.svg": 68484,
	"./svg/module/tests-done.svg": 41524,
	"./svg/module/tests.svg": 32971,
	"./svg/module/video-done.svg": 34626,
	"./svg/module/video.svg": 43605,
	"./svg/no-image copy.svg": 53783,
	"./svg/no-image.svg": 2432,
	"./svg/not-verified.svg": 7001,
	"./svg/official-certificate.svg": 14832,
	"./svg/pass-error.svg": 19923,
	"./svg/pass.svg": 12366,
	"./svg/pdf-com.svg": 35629,
	"./svg/period.svg": 66490,
	"./svg/person.svg": 61358,
	"./svg/plus.svg": 62833,
	"./svg/premium.svg": 38648,
	"./svg/shield.svg": 86986,
	"./svg/sparkling.svg": 78232,
	"./svg/star.svg": 30289,
	"./svg/success.svg": 69102,
	"./svg/teacher.svg": 19273,
	"./svg/telegram.svg": 1296,
	"./svg/tg.svg": 49838,
	"./svg/upload.svg": 45294,
	"./svg/uzcard.svg": 75086,
	"./svg/video-square.svg": 85610,
	"./svg/warn.svg": 94973,
	"./svg/webinar.svg": 97909,
	"./tailwind.scss": 39137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86006;